import apiClient from "@/client";

export default {
  post: {
    sendOTP: (accountSlug, phone, transactionalCommunications, marketingCommunications) => {
      return apiClient.post(`/public/otp/send`, {
        phone,
        account_slug: accountSlug,
        dnd_transaction: !transactionalCommunications,
        dnd_marketing: !marketingCommunications,
      });
    },
    resendOTP: (phone) => {
      return apiClient.post(`/public/otp/resend`, {
        phone,
      });
    },
    verifyOTP: (accountSlug, phone, otp) => {
      return apiClient.post(`/public/otp/verify`, {
        account_slug: accountSlug,
        phone,
        otp,
      });
    },
    // email otp
    sendEmailOTP: (accountSlug, phone, transactionalCommunications, marketingCommunications) => {
      return apiClient.post(`/public/otp/email/send`, {
        phone,
        account_slug: accountSlug,
        dnd_transaction: !transactionalCommunications,
        dnd_marketing: !marketingCommunications,
      });
    },
    resendEmailOTP: (accountSlug, phone) => {
      return apiClient.post(`/public/otp/email/resend`, {
        phone,
        account_slug: accountSlug,
      });
    },
    verifyEmailOTP: (accountSlug, phone, otp) => {
      return apiClient.post(`/public/otp/email/verify`, {
        account_slug: accountSlug,
        phone,
        otp,
      });
    },
  },
};
